import { render, staticRenderFns } from "./borrowing.vue?vue&type=template&id=12d5b998&scoped=true"
import script from "./borrowing.vue?vue&type=script&lang=js"
export * from "./borrowing.vue?vue&type=script&lang=js"
import style0 from "./borrowing.vue?vue&type=style&index=0&id=12d5b998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d5b998",
  null
  
)

export default component.exports